import script from "./UserHeadTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserHeadTop.vue?vue&type=script&lang=ts&setup=true"

import "./UserHeadTop.vue?vue&type=style&index=0&id=1652ab5c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1652ab5c"]])

export default __exports__